<template>
    <div class="p-2">
        <!-- Login successfuly.
        <a :href="this.$route.query.redirect + '?token=' + token" >back to your site</a>
        
        <div class="mt-1">
            Redirecting to the {{ this.$route.query.redirect }} in 2 seconds.
        </div> -->
    </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
    data() {
        return {
            token: Cookies.get('tenantToken')
        };
    },
    mounted() {
        this.token = Cookies.get('centralToken');
        location.href = this.$route.query.redirect + '?token=' + this.token;
    }
};
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/LoginSSOSuccess.vue